import { render, staticRenderFns } from "./Form9.vue?vue&type=template&id=e18e2b1a&scoped=true&"
import script from "./Form9.vue?vue&type=script&lang=ts&"
export * from "./Form9.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e18e2b1a",
  null
  
)

export default component.exports